import React, { useState } from "react";

const FALLBACK = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><rect width='200' height='200' fill='%23EFECE6'/><g fill='%238A8782' font-family='Georgia,serif'><text x='100' y='100' font-size='42' text-anchor='middle' dominant-baseline='middle' opacity='0.6'>M</text><text x='100' y='140' font-size='10' text-anchor='middle' letter-spacing='2'>MAPLE</text></g></svg>";

export default function SafeImage({ src, alt, className, fallback = FALLBACK, ...rest }) {
  const [errored, setErrored] = useState(false);
  return (
    <img
      src={errored || !src ? fallback : src}
      alt={alt || ""}
      className={className}
      onError={() => setErrored(true)}
      loading="lazy"
      {...rest}
    />
  );
}
